exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.page-alert[data-v-520a3e00] { margin-bottom: 16px;\n}\n", ""]);

// exports
